import BaseModelAPI from '../BaseModelAPI';

export default class DistributionType extends BaseModelAPI {
	static entity = 'distributiontype';
	static entityName = 'distributiontype';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}